export default __webpack_public_path__ + "static/7-19b8774413194049f9562fa7903e6733.jpg";